export default {"src":"/_next/static/media/0x95d7337d43340e2721960dc402d9b9117f0d81a2.5cd1c695.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};